exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n    padding: 2em\r\n}\r\n\r\nh3 {\r\n    margin: 0\r\n}\r\n\r\n.container {\r\n    padding-bottom: 0\r\n}\r\n\r\n.parent-div {\r\n    width: 100%;\r\n    float: left;\r\n}\r\n\r\n.left-box {\r\n    float: left;\r\n    width: 50%;\r\n    padding-right: 10px;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n}\r\n\r\n.right-box {\r\n    float: right;\r\n    width: 50%;\r\n    padding-left: 10px;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n}\r\n\r\n.program-button {\r\n    margin-top: -10px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillsets.component.css
// module id = ../../../../../src/app/collateralskillsets/collateralskillsets.component.css
// module chunks = main